export enum DIALOG_ACTION_TYPES {
    OPEN_DIALOG = 'dialog/OPEN_DIALOG',
    CLOSE_DIALOG = 'dialog/CLOSE_DIALOG',
}

export enum DIALOG_TYPES {
    SELECT_PROJECT = 'SELECT_PROJECT',
    SELECT_ATTACHMENT_ACTION = 'SELECT_ATTACHMENT_ACTION',
    REJECT_ATTACHMENT = 'REJECT_ATTACHMENT',
    REPLACE_ATTACHMENT = 'REPLACE_ATTACHMENT',
    SHARE_SCENE_3D = 'SHARE_SCENE_3D',
    COMPLETE_NODE = 'COMPLETE_NODE',
    NEXT_STEP_NODE = 'NEXT_STEP_NODE',
}
